import { createApiAction } from '@app/packages/api/utils'
import type { ApiYandexMapsReview, ApiYandexMapsReviewsSummary } from '@app/packages/api/v2/types/entities'
import type { ReviewsPageMeta, YandexMapsReviewRequest } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export const getYandexMapsReviewsByQuery = (request: YandexMapsReviewRequest) =>
  createApiAction('getYandexMapsReviewsByQuery', dispatch =>
    dispatch<{ data: ApiYandexMapsReview[]; meta: ReviewsPageMeta }>({ method: 'GET', endpoint: v2Path('/api/v2/yandex_maps_reviews', request) })
  )

export const getYandexMapsReviewsSummary = () =>
  createApiAction('getYandexMapsReviewsSummary', dispatch =>
    dispatch<{ data: ApiYandexMapsReviewsSummary }>({ method: 'GET', endpoint: '/api/v2/yandex_maps_reviews/summary' })
  )
